import React from 'react';
import { useLocation } from 'react-router-dom';
import {
  CalendarViewWeekOutlined as WeekIcon,
  ShowChartOutlined as TimelineIcon,
  TuneOutlined as UsualIcon,
} from '@mui/icons-material';
import { NavPanel, PanelGroup, PanelLink } from '../../components/layout/NavPanel';

const SchedulePanel: React.FC = () => {
  const { pathname } = useLocation();
  return (
    <NavPanel>
      <PanelGroup label="Schedule">
        <PanelLink to="/schedule" exact icon={<WeekIcon />} label="Week" currentPath={pathname} />
        <PanelLink to="/schedule/timeline" icon={<TimelineIcon />} label="Timeline" currentPath={pathname} />
        <PanelLink to="/schedule/usual" icon={<UsualIcon />} label="Usual week" currentPath={pathname} />
      </PanelGroup>
    </NavPanel>
  );
};

export default SchedulePanel;
